import React from 'react'
import { AppContext } from '../../App'
import * as Request from '../../utilities/request'

import { Col, Row } from 'react-bootstrap'
import { Loading } from '../ui/Loading/Loading'
import { dollarFormat } from '../../utilities/format'
import { UnaddressedWip } from '../../../../back-end/common/billyDashboard'
import DashboardCard from './dashboardCard'
import { TestingStaff } from '../../screens/dashboard/dashboardWrapper'

interface UnaddressedWipProps {
	firmView: boolean
	testingStaff?: TestingStaff
}

const UnaddressedWipCard = (props: UnaddressedWipProps) => {
	const { appState } = React.useContext(AppContext)

	const [unaddressedWip, setUnaddressedWip] = React.useState<UnaddressedWip | null>(null)
	const [errorMsg, setErrorMsg] = React.useState<string | null>(null)

	React.useEffect(() => {
		const getData = async () => {
			const testingStaffXpmID = props.testingStaff ? '/' + props.testingStaff.xpmID : ''
			const unaddressedWipRes = await Request.get(`billydashboard/unaddressedwip${testingStaffXpmID}?firm=${props.firmView}`)

			setUnaddressedWip(unaddressedWipRes.data.unaddressedWip)

			if (!unaddressedWipRes.data.success) {
				setErrorMsg(unaddressedWipRes.data.message)
			}
		}

		setUnaddressedWip(null)
		setErrorMsg(null)
		if (appState.authState.isLoggedIn) {
			getData()
		}
	}, [appState.authState, props])

	if (errorMsg) {
		return (
			<DashboardCard background="royal-blue">
				<div className="center-flex p-3">
					<span className="span-body-2 span-white">{errorMsg}</span>
				</div>
			</DashboardCard>
		)
	}

	if (!unaddressedWip) {
		return (
			<DashboardCard background="royal-blue">
				<div className="center-flex">
					<Loading show style={{ color: 'white' }} />
				</div>
			</DashboardCard>
		)
	}

	const colWidth = {
		label: 4,
		current: 4,
		prev: 4,
	}

	return (
		<DashboardCard background="royal-blue">
			<Row>
				<Col className="d-flex flex-column">
					<span className="span-body-2 span-bold span-white">UNADDRESSED WIP</span>

					<span className="font-800-50-58 span-white">{dollarFormat(unaddressedWip.totalUnaddressed)}</span>
				</Col>
			</Row>
			<Row className="pt-4">
				<Col sm={colWidth.label}></Col>
				<Col sm={colWidth.current} className="d-flex justify-content-end">
					<span className="span-body-2 span-bold span-white">THIS PERIOD</span>
				</Col>
				<Col sm={colWidth.prev} className="d-flex justify-content-end">
					<span className="span-body-2 span-bold span-white">LAST YEAR</span>
				</Col>
			</Row>
			<Row>
				<Col sm={colWidth.label}>
					<span className="span-body-2 span-white">Opening WIP</span>
				</Col>
				<Col sm={colWidth.current} className="d-flex justify-content-end">
					<span className="span-body-2 span-white">{dollarFormat(unaddressedWip.openingWIP)}</span>
				</Col>
				<Col sm={colWidth.prev} />
			</Row>
			<Row>
				<Col sm={colWidth.label}>
					<span className="span-body-2 span-white">Production</span>
				</Col>
				<Col sm={colWidth.current} className="d-flex justify-content-end">
					<span className="span-body-2 span-white">{dollarFormat(unaddressedWip.production)}</span>
				</Col>
				<Col sm={colWidth.prev} />
			</Row>
			<Row>
				<Col sm={colWidth.label}>
					<span className="span-body-2 span-white">In Process</span>
				</Col>
				<Col sm={colWidth.current} className="d-flex justify-content-end">
					<span className="span-body-2 span-white">{dollarFormat(unaddressedWip.invoicedDraftAndAwaitingApproval)}</span>
				</Col>
				<Col sm={colWidth.prev} className="d-flex justify-content-end">
					<span className="span-body-2 span-white">{dollarFormat(unaddressedWip.invoicedDraftAndAwaitingApprovalPrevious)}</span>
				</Col>
			</Row>
			<Row>
				<Col sm={colWidth.label}>
					<span className="span-body-2 span-white">Invoiced</span>
				</Col>
				<Col sm={colWidth.current} className="d-flex justify-content-end">
					<span className="span-body-2 span-white">{dollarFormat(unaddressedWip.invoicedApproved)}</span>
				</Col>
				<Col sm={colWidth.prev} className="d-flex justify-content-end">
					<span className="span-body-2 span-white">{dollarFormat(unaddressedWip.invoicedApprovedPrevious)}</span>
				</Col>
			</Row>
			<Row>
				<Col sm={colWidth.label}>
					<span className="span-body-2 span-white">W/O/U In Process</span>
				</Col>
				<Col sm={colWidth.current} className="d-flex justify-content-end">
					<span className="span-body-2 span-white">{dollarFormat(unaddressedWip.writtenOffUpDraftAndAwaitingApproval)}</span>
				</Col>
				<Col sm={colWidth.prev} className="d-flex justify-content-end">
					<span className="span-body-2 span-white">{dollarFormat(unaddressedWip.writtenOffUpDraftAndAwaitingApprovalPrevious)}</span>
				</Col>
			</Row>
			<Row>
				<Col sm={colWidth.label}>
					<span className="span-body-2 span-white">Written Off/Up</span>
				</Col>
				<Col sm={colWidth.current} className="d-flex justify-content-end">
					<span className="span-body-2 span-white">{dollarFormat(unaddressedWip.writtenOffUpApproved)}</span>
				</Col>
				<Col sm={colWidth.prev} className="d-flex justify-content-end">
					<span className="span-body-2 span-white">{dollarFormat(unaddressedWip.writtenOffUpApprovedPrevious)}</span>
				</Col>
			</Row>
		</DashboardCard>
	)
}

export default UnaddressedWipCard
